import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/base/services/base.service';
import { Observable } from 'rxjs';
import { PontosCriticosProjeto } from '../models/pontos-criticos-projeto.model';

@Injectable({
  providedIn: 'root'
})
export class PontosCriticosAgregadorIndicadorService extends BaseService<PontosCriticosProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public solicitarNovaSituacao(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/nova-situacao/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/pontos-criticos/agregador-indicador';
  }
}
